import BaseButton from '../base-button';

import { GenesisCtaFlavor, GenesisFlavor } from './genesis-button';

export const CtaButton = GenesisCtaFlavor(BaseButton);
export const Button = GenesisFlavor(BaseButton);
